export default function Hero() {
  const go = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  return (
    <section id="home" className="relative overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20editorial%20abstract%20background%20with%20coral%20red%20and%20fresh%20green%20watercolor%20blobs%20on%20dark%20charcoal%20paper%2C%20scattered%20small%20citrus%20slices%20and%20confetti%2C%20playful%20gossip%20community%20vibe%2C%20soft%20gradients%2C%20modern%20minimal%20illustration%2C%20high%20contrast%20deep%20tones&width=1600&height=900&seq=chigua-hero-x1&orientation=landscape"
          alt="53吃瓜热门话题讨论社区氛围背景图"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/90"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-24 pt-32 text-center md:px-6 md:pt-40">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          <span className="inline-block h-2 w-2 rounded-full bg-accent-400"></span>
          今日热榜已更新 · 瓜友持续投稿中
        </span>

        <h1 className="mt-6 font-heading text-5xl leading-tight text-background-50 md:text-7xl">
          53吃瓜，追更今天的热门话题
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-50/85 md:text-lg">
          想参与投稿发帖，或追更今天的瓜和最新话题？这里汇总瓜友投稿、热门话题与每日更新，
          既能看新瓜也能一起唠嗑，随时跟进最新动态不落伍。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
          <button
            onClick={() => go('feed')}
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-400"
          >
            <i className="ri-fire-line text-lg"></i>
            刷最新投稿
          </button>
          <button
            onClick={() => go('post')}
            className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-bold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
          >
            <i className="ri-edit-2-line text-lg"></i>
            马上投稿发帖
          </button>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-background-50/70">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap"><i className="ri-flashlight-fill text-accent-400"></i> 今日新瓜 2600+</span>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap"><i className="ri-team-fill text-accent-400"></i> 在线唠嗑 1.8万+</span>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap"><i className="ri-chat-3-fill text-accent-400"></i> 今日互动 86万+</span>
        </div>
      </div>
    </section>
  );
}